import React from "react";
import CirclePercentage from "../components/CirclePercentage";
import {Col, Container, Row} from "react-bootstrap";
import {Bar} from "react-chartjs-2";
import {config} from "../components/Constants";

class MainPage extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            allEvents: 0,
            finishedEvents: 0,
            canceledEvents: 0,
            calculations: 0,
            chart: null
        };
    }

    componentDidMount() {
        fetch(config.API_URL + '/api/main', {
            credentials: 'include'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            allEvents: 0,
                            finishedEvents: 0,
                            isLoaded: true,
                            error: result.error
                        });
                    } else if (result) {
                        this.setState({
                            allEvents: result.all,
                            finishedEvents: result.finished,
                            canceledEvents: result.canceled,
                            calculations: result.calculations,
                            chart: result.chart,
                            isLoaded: true
                        });
                    }
                },
                (error) => {
                    this.setState({
                        allEvents: 0,
                        finishedEvents: 0,
                        isLoaded: true,
                        error: error
                    });
                }
            )
    }

    render(){
        const {error, isLoaded, allEvents, finishedEvents, canceledEvents, calculations, chart} = this.state;
        const data = {
            labels: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
            datasets: [
                {
                    label: 'Liczba przygotowywanych ofert na poszczególne miesiące w '+new Date().getFullYear(),
                    backgroundColor: 'rgba(13,70,139,0.79)',
                    borderColor: 'rgba(13,70,139,1)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(13,70,139,0.4)',
                    hoverBorderColor: 'rgba(13,70,139,1)',
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }
            ]
        };
        if(chart){
            for(var x = 0; x < chart.length; x++){
                data.datasets[0].data[chart[x].miesiac - 1]=chart[x].ilosc;
            }
        }
        return(
            <React.Fragment>
                <header className="clients-header">
                    <h1>Podsumowanie roku {new Date().getFullYear()}</h1>
                </header>
                <div className="MainPage-div">
                    <Container fluid={true}>
                        <Row className="align-content-stretch MainPage-row">
                            <Col md={12} lg={6}>
                                <Container fluid={true}>
                                    <Row className="align-content-center">
                                        <Col sm={12} md={4}>
                                            <CirclePercentage className="blue" text={finishedEvents} text2="Imprez" text3="zrealizowanych" percent={Math.round(100*finishedEvents/allEvents)}/>
                                        </Col>
                                        <Col sm={12} md={4}>
                                            <CirclePercentage className="green" text={canceledEvents} text2="Imprez" text3="anulowanych" percent={Math.round(100*canceledEvents/allEvents)}/>
                                        </Col>
                                        <Col sm={12} md={4}>
                                            <CirclePercentage className="violet" text={calculations} text2="Kalkulacji" text3="bez blokady sal" percent={Math.round(100*calculations/allEvents)}/>
                                        </Col>
                                    </Row>
                                </Container>
                                <div className="summary">
                                    <span>
                                        Wszystkich &bull; <strong>{allEvents}</strong> imprez
                                    </span>
                                </div>
                            </Col>
                            <Col md={12} lg={6}>
                                <Bar
                                    data={data}
                                    width={100}
                                    height={40}
                                    options={{
                                        maintainAspectRatio: true,
                                        responsive: true
                                    }}
                                />
                                <div className="summary">
                                    <span>
                                        Imprez/Obiekty
                                    </span>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }

}

export default MainPage;
